import { newObjectId } from './objectId';

/**
 * A stable id for this browser tab, for the lifetime of the page.
 *
 * The ops endpoint echoes it back in the `canvasOpsApplied` broadcast so a tab can
 * recognise and drop its own batch — it has already applied those ops optimistically
 * and re-applying them would be pointless work.
 *
 * Deliberately not the user id: one author with the editor open in two tabs is two
 * independent copies of the graph, and each has to see the other's edits. Also
 * deliberately not `socket.id`, which changes on every reconnect — this identifies
 * the tab, not its current connection.
 */
const CLIENT_ID = newObjectId();

export default CLIENT_ID;
